import React from 'react';
import { useTranslation } from 'react-i18next';
import { RatingLink } from '@sections/shared/SEOContentSection/SEOContentSection.styles';
import { WW_APP_STORE_URLS } from '@sections/wedding-website/wwAppRating.constants';
import { StyledSection, StyledHeading, AppRatingRow } from './RegistryAppRatingSection.styles';

interface RegistryAppRatingSectionProps {
  ratingValue: number;
  ratingCount: number;
}

export const RegistryAppRatingSection: React.FC<RegistryAppRatingSectionProps> = ({ ratingValue, ratingCount }) => {
  const { t, i18n } = useTranslation('registry');
  const interpolation = {
    ratingValue: ratingValue.toLocaleString(i18n.language, { minimumFractionDigits: 1, maximumFractionDigits: 1 }),
    ratingCount: ratingCount.toLocaleString(i18n.language),
  };

  return (
    <StyledSection as="section" id="Registry_App_Rating">
      <StyledHeading tagName="h2" variant="hed40" color="mono1">
        {t('appRating.heading')}
      </StyledHeading>
      <AppRatingRow>
        <span className="registry-rating-stars" aria-hidden="true">
          ★★★★★
        </span>
        <RatingLink
          href={WW_APP_STORE_URLS[0]}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('appRating.ariaLabel', interpolation)}
        >
          {t('appRating.text', interpolation)}
        </RatingLink>
      </AppRatingRow>
    </StyledSection>
  );
};
